export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11197.671f2579.jpg";